const ENDPOINT = `${process.env.REACT_APP_BACKEND_URL}/api/ops/client-errors`;
const seen = new Map();
let installed = false;

const cleanPath = (value) => {
  if (!value) return "";
  try {
    const url = new URL(String(value), window.location.origin);
    return url.pathname;
  } catch {
    return String(value).split("?", 1)[0].slice(0, 160);
  }
};

const messageFrom = (value, fallback) => {
  if (typeof value === "string") return value;
  if (value?.message) return value.message;
  return fallback;
};

export const reportClientHealth = (report = {}) => {
  if (typeof window === "undefined" || window.location.pathname.startsWith("/admin")) return;

  const payload = {
    kind: report.kind || "javascript_error",
    severity: report.severity || "error",
    message: messageFrom(report.message, "Customer browser operation failed").slice(0, 300),
    page: window.location.pathname,
    action: (report.action || "").slice(0, 80),
    component: (report.component || "").slice(0, 80),
    request_path: cleanPath(report.request_path),
    status_code: Number.isInteger(report.status_code) ? report.status_code : null,
    browser: navigator.userAgent.slice(0, 160),
    session_id: localStorage.getItem("vb_session") || "",
  };

  const fingerprint = [payload.kind, payload.message, payload.page, payload.action, payload.request_path].join("|");
  const now = Date.now();
  if (now - (seen.get(fingerprint) || 0) < 5000) return;
  seen.set(fingerprint, now);
  if (seen.size > 100) seen.delete(seen.keys().next().value);

  const body = JSON.stringify(payload);
  try {
    if (navigator.sendBeacon) {
      const accepted = navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "application/json" }));
      if (accepted) return;
    }
    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      credentials: "include",
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Monitoring must never interfere with the customer journey.
  }
};

export const installClientHealthMonitoring = () => {
  if (installed || typeof window === "undefined") return;
  installed = true;

  window.addEventListener("error", (event) => {
    if (event.target && event.target !== window) {
      const target = event.target;
      reportClientHealth({
        kind: "resource_error",
        message: `Resource failed to load: ${target.tagName || "resource"}`,
        action: "load_resource",
        component: target.tagName || "resource",
        request_path: target.currentSrc || target.src || target.href,
      });
      return;
    }
    reportClientHealth({
      kind: "javascript_error",
      message: event.error || event.message,
      action: "window_error",
      component: "window",
      request_path: event.filename,
    });
  }, true);

  window.addEventListener("unhandledrejection", (event) => {
    reportClientHealth({
      kind: "promise_rejection",
      message: messageFrom(event.reason, "Unhandled browser promise rejection"),
      action: "unhandled_promise",
      component: "window",
    });
  });
};
